// ***************
// src/app/agendexColaborador/services/pc_userUtils.js
// objetivo: encriptar e decriptar tokens
// autor: WdePaula / MVinfo 
// data: 17/10/24 | 20h41 - cópia (semelhante à do agendex cliente web) exclusiva para uso somente no prestador
// ***************




import { decrypt } from '../../../Services/cryptoUtils';

export const pc_getUserData = () => {
    const encryptedTokenLG = localStorage.getItem('tokenlg');
    const encryptedTokenAPW = localStorage.getItem('tokenapw');

    if (encryptedTokenLG && encryptedTokenAPW ) {
        try {
            const decryptedTokenLG = decrypt(encryptedTokenLG);
            const decryptedTokenAPW = decrypt(encryptedTokenAPW);

            if (decryptedTokenLG === "true") {
                // Assumindo que decryptedTokenAcw já é um objeto JavaScript
                const userObject = decryptedTokenAPW;
                // console.log('dentro do decrypt p_userUtils: ', userObject);
                return {
                    userId: userObject.id_usuario || 0,
                    colaboradorId: userObject.id_colaborador || 0,
                    indEmpresa: userObject.indempresa || 0,
                    validado: userObject.validado || 0, // acrescentado 4/10/24w (0=cpfcnpj não verificado / 1=verificado)
                    bloqueio: userObject.lock || 0, // acrescentado 4/10/24w (0=cpfcnpj não verificado / 1=verificado)
                    TAMANHO_PAGINA: userObject.TAMANHO_PAGINA || 10, // acrescentado tamanho página
                    dias_FimContrato: userObject.diasFimContrato || 0 // mínimo de 0 dia para encerrar contrato 7/12/24w
                    // tipoAtendimento: userObject.tipoAtendimento || 0, // 0=não tem funcionário / 1=tem funcionários
                    // tipoAgenda: userObject.tipoAgenda || 0, // 0=global / 1=individual // 15/10/24w
                    // agenda_fechada: userObject.agenda_fechada || 0, // 0=aberta / 1=fechada // 15/10/24w
                    // cidade: userObject.cidade || '',
                    // emailValidado: userObject.ativa_conta || 0,
                };
                 
            } else {
                // return { userId: 0, emailValidado: 0, indEmpresa: 0, tipoAtendimento: 0, cidade: ''};
                return { userId: 0, colaboradorId: 0, TAMANHO_PAGINA: 10 };

            }
        } catch (error) {
            console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
            return { userId: 0, colaboradorId: 0, TAMANHO_PAGINA: 10 };
        }
    }

    return { userId: 0, colaboradorId: 0, TAMANHO_PAGINA: 10 };
};